import withColor from 'util/hoc/with-color';
import styled, { keyframes} from 'styled-components';

export const StyledCareerClusterCheckbox = withColor(styled.div`
  background: #FCF1D1;
  border-radius: 8px;
  height: 82px;
  width: 258px;
  display: flex;
  align-items: center;
  padding: 10px;
  margin-bottom: 1em;
  cursor: pointer;
  .check-circle {
    height: 55px;
    width: 55px;
    background-color: #FFE79F;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    svg {
      height: ${props => props.active ? '25px' : '0px'};
      width: ${props => props.active ? '25px' : '0px'};
      color: ${props => props.colors.secondary};
    }
  }
  .question-title {
    width: 160px;
    margin-left: 20px;
    color: #2E2E2E;
    font-size: 14px;
    line-height: 17px;
  }
`);

export const rotatedown = keyframes`
    0% {opacity: 1; bottom: -2px;}
    75% {opacity: 0; transform: rotate(90deg); bottom: -40px;}
  }
`;

export const rotateup = keyframes`
    0% {transform: scale(0.2); bottom: 0px;}
    80% {transform: scale(1.3);}
    100% {transform: scale(1.0); bottom: -2px;}
  }
`;

export const RotateDown = styled.div`
  display: inline-block;
  position: relative;
  animation: ${rotatedown} 450ms ease-in infinite;
`;

export const RotateUp = styled.div`
  display: inline-block;
  position: relative;
  animation: ${rotateup} 420ms ease-in infinite;
`;
